export default {
  Weight110Icon: () =>
    import(
      /* webpackChunkName: "OneHundredTenIcon" */ '@/js/components/Shared/IconSelect/Icons/Weights/110Icon.vue'
    ),
  Weight120Icon: () =>
    import(
      /* webpackChunkName: "OneHundredFiftyIcon" */ '@/js/components/Shared/IconSelect/Icons/Weights/120Icon.vue'
    ),
  Weight130Icon: () =>
    import(
      /* webpackChunkName: "OneHundredFiftyIcon" */ '@/js/components/Shared/IconSelect/Icons/Weights/130Icon.vue'
    ),
  Weight135Icon: () =>
    import(
      /* webpackChunkName: "OneHundredFiftyIcon" */ '@/js/components/Shared/IconSelect/Icons/Weights/135Icon.vue'
    ),
  Weight150Icon: () =>
    import(
      /* webpackChunkName: "OneHundredFiftyIcon" */ '@/js/components/Shared/IconSelect/Icons/Weights/150Icon.vue'
    ),
}
